<template>
  <section class="quick-quote-info">
    <div class="table">
      <template v-if="quoteForm.class_id === 14">
        <div class="tr">
          <span>Motor Type</span>
          <span v-copy="getOptionName('classOptions', quoteForm.class_id)">{{ getOptionName('classOptions', quoteForm.class_id) }}</span>
        </div>
        <div class="tr">
          <span>Will the vehicle be used for commercial purpose?</span>
          <span>{{ getAllOptionName('mc_usage', quoteForm.usage_ind) }}</span>
        </div>
        <div class="tr">
          <span>Make</span>
          <span v-copy="getAllOptionName('brand', quoteForm.brand_id)">{{ getAllOptionName('brand', quoteForm.brand_id) }}</span>
        </div>
        <div class="tr">
          <span>Body Type</span>
          <span v-copy="getAllOptionName('typ_of_bdy', quoteForm.typ_of_bdy_id)">{{ getAllOptionName('typ_of_bdy', quoteForm.typ_of_bdy_id) }}</span>
        </div>
        <div class="tr">
          <span>Cylinder Capacity</span>
          <span v-copy="`${quoteForm.engn_cpcty} cc`">{{ quoteForm.engn_cpcty}} cc</span>
        </div>
        <div class="tr">
          <span>Year of Manufacture</span>
          <span v-copy="getAllOptionName('rgtn_yr', quoteForm.rgtn_yr)">{{ getAllOptionName('rgtn_yr', quoteForm.rgtn_yr) }}</span>
        </div>
        <div class="tr">
          <span>NCD</span>
          <span v-copy="getAllOptionName('ncd', quoteForm.ncd_pct)">{{ getAllOptionName('ncd', quoteForm.ncd_pct) }}</span>
        </div>
        <div class="tr">
          <span>Coverage</span>
          <span v-copy="getOptionName('allCoverTypeOptions', quoteForm.trm_of_cvr)">{{ getOptionName('allCoverTypeOptions', quoteForm.trm_of_cvr) }}</span>
        </div>
        <div class="tr">
          <span>Number of Named Driver(s)</span>
          <span v-copy="quick_quote_detail.no_of_nm_drvr">{{quick_quote_detail.no_of_nm_drvr}}</span>
        </div>
        <div
          v-if="quoteForm.no_acci_nor_deduct==0"
          class="tr">
          <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>
          <span v-copy="getOptionName('yesNoOptions', quoteForm.no_acci_nor_deduct)">{{ getOptionName('yesNoOptions', quoteForm.no_acci_nor_deduct) }}</span>
        </div>
        <div
          v-if="quoteForm.no_acci_nor_deduct!=0"
          class="tr">
          <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
          <span v-copy="getOptionName('acciOptions', quoteForm.no_dr_acci_ind)">{{ getOptionName('acciOptions', quoteForm.no_dr_acci_ind) }}</span>
        </div>
        <div
          v-if="quoteForm.no_acci_nor_deduct!=0"
          class="tr">
          <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years? </span>
          <span v-copy="getOptionName('deductOptions', quoteForm.no_dr_deduct_ind)">{{ getOptionName('deductOptions', quoteForm.no_dr_deduct_ind) }}</span>
        </div>
      </template>
      <template v-if="quoteForm.class_id===12">
        <div class="tr">
          <span>Car Type</span>
          <span v-copy="getOptionName('classOptions', quoteForm.class_id)">{{ getOptionName('classOptions', quoteForm.class_id) }}</span>
        </div>

        <div class="tr">
          <span>Make</span>
          <span v-copy="getAllOptionName12('brand', quoteForm.brand_id)">{{ getAllOptionName12('brand', quoteForm.brand_id) }}</span>
        </div>
        <div class="tr">
          <span>Vehicle Type</span>
          <span v-copy="getAllOptionName12('typ_of_mix', quoteForm.typ_of_bdy_mix_id)">{{ getAllOptionName12('typ_of_mix', quoteForm.typ_of_bdy_mix_id) }}</span>
        </div>
        <div class="tr">
          <span>Tonnage</span>
          <span v-copy="quoteForm.tonnage">{{ quoteForm.tonnage }}</span>
        </div>
        <div class="tr">
          <span>Year of Manufacture</span>
          <span v-copy="getAllOptionName12('rgtn_yr', quoteForm.rgtn_yr)">{{ getAllOptionName12('rgtn_yr', quoteForm.rgtn_yr) }}</span>
        </div>
        <div class="tr">
          <span>NCD</span>
          <span v-copy="getAllOptionName12('ncd', quoteForm.ncd_pct)">{{ getAllOptionName12('ncd', quoteForm.ncd_pct) }}</span>
        </div>
        <div class="tr">
          <span>Coverage</span>
          <span v-copy="getOptionName('allCoverTypeOptions', quoteForm.trm_of_cvr)">{{ getOptionName('allCoverTypeOptions', quoteForm.trm_of_cvr) }}</span>
        </div>
        <div
          v-if="quoteForm.trm_of_cvr!==1"
          class="tr">
          <span>Vehicle Market Value (Sum Insured)</span>
          <span v-copy="amount">{{  quoteForm.isrd_vl|formatMoney(2, true) }}</span>
        </div>
        <!--        <div-->
        <!--          class="tr">-->
        <!--          <span>Are all the driver(s) 25-65 years old?</span>-->
        <!--          <span v-copy="getOptionName('yesNoOptions', quoteForm.enough_age_ind)">{{ getOptionName('yesNoOptions', quoteForm.enough_age_ind) }}</span>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          class="tr">-->
        <!--          <span>Does all the named driver(s) have over 2 years of a proper commercial vehicle driving license?</span>-->
        <!--          <span v-copy="getOptionName('yesNoOptions', quoteForm.enough_exp_ind)">{{ getOptionName('yesNoOptions', quoteForm.enough_exp_ind) }}</span>-->
        <!--        </div>-->
        <div
          class="tr">
          <span>Will the vehicle be used by third party for carrying goods for reward?</span>
          <span v-copy="getOptionName('yesNoOptions', quoteForm.use_carrying_profit_ind)">{{ getOptionName('yesNoOptions', quoteForm.use_carrying_profit_ind) }}</span>
        </div>
        <!--        <div-->
        <!--          v-if=" quoteForm.no_acci_nor_deduct==0"-->
        <!--          class="tr">-->
        <!--          <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>-->
        <!--          <span v-copy="getOptionName('yesNoOptions', quoteForm.no_acci_nor_deduct)">{{ getOptionName('yesNoOptions', quoteForm.no_acci_nor_deduct) }}</span>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          v-if="quoteForm.no_acci_nor_deduct!=0"-->
        <!--          class="tr">-->
        <!--          <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>-->
        <!--          <span v-copy="getOptionName('acciOptions', quoteForm.no_dr_acci_ind)">{{ getOptionName('acciOptions', quoteForm.no_dr_acci_ind) }}</span>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          v-if="quoteForm.no_acci_nor_deduct!=0"-->
        <!--          class="tr">-->
        <!--          <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years? </span>-->
        <!--          <span v-copy="getOptionName('deductOptions', quoteForm.no_dr_deduct_ind)">{{ getOptionName('deductOptions', quoteForm.no_dr_deduct_ind) }}</span>-->
        <!--        </div>-->
      </template>
      <template v-if="quoteForm.class_id===11">
        <div class="tr">
          <span>Car Type</span>
          <span v-copy="getOptionName('classOptions', quoteForm.class_id)">{{ getOptionName('classOptions', quoteForm.class_id) }}</span>
        </div>
        <div class="tr">
          <span>Make</span>
          <!--          <span>{{ getAllOptionName12('brand', quoteForm.brand_id) }}</span>-->
          <span v-copy="getAllOptionName11('brand', quoteForm.brand_id)">{{ getAllOptionName11('brand', quoteForm.brand_id) }}</span>
        </div>

        <div class="tr">
          <span>Model</span>
          <span v-copy="getOptionName('carModelOptions', quoteForm.model_id)">{{ getOptionName('carModelOptions', quoteForm.model_id) }}</span>
        </div>
        <div class="tr">
          <span>Body Type</span>
          <span v-copy="getAllOptionName11('typ_of_bdy', quoteForm.typ_of_bdy_id)">{{ getAllOptionName11('typ_of_bdy', quoteForm.typ_of_bdy_id) }}</span>
        </div>
        <div
          class="tr">
          <span>Cylinder Capacity (Input "0" for EV)</span>
          <span v-copy="`${quoteForm.engn_cpcty } cc`">{{ quoteForm.engn_cpcty }} cc</span>
        </div>
        <div class="tr">
          <span>Year of Manufacture</span>
          <span v-copy="getAllOptionName11('rgtn_yr', quoteForm.rgtn_yr)">{{ getAllOptionName11('rgtn_yr', quoteForm.rgtn_yr) }}</span>
        </div>
        <div class="tr">
          <span>NCD</span>
          <span v-copy="getAllOptionName11('ncd', quoteForm.ncd_pct)">{{ getAllOptionName11('ncd', quoteForm.ncd_pct) }}</span>
        </div>
        <div class="tr">
          <span>Coverage</span>
          <span v-copy="getOptionName('allCoverTypeOptions', quoteForm.trm_of_cvr)">{{ getOptionName('allCoverTypeOptions', quoteForm.trm_of_cvr) }}</span>
        </div>
        <div
          v-if="quoteForm.trm_of_cvr!==1"
          class="tr">
          <span>Vehicle Market Value (Sum Insured)</span>
          <span v-copy="amount">{{  quoteForm.isrd_vl|formatMoney(2, true) }}</span>
        </div>
        <div class="tr">
          <span>Number of Named Driver(s)</span>
          <span v-copy="getOptionName('numberFourOptions', quoteForm.no_of_nm_drvr) ">{{ getOptionName('numberFourOptions', quoteForm.no_of_nm_drvr) }}</span>
        </div>
        <div class="tr">
          <span v-if="quoteForm.enough_age_ind==1">Are all the driver(s) 25-65 years old?</span>
          <span v-else>Are all the driver(s) 31-60 years old?</span>
          <span
            v-if="quoteForm.enough_age_ind==1"
            v-copy="getOptionName('yesNoOptions', quoteForm.enough_age_ind)">{{ getOptionName('yesNoOptions', quoteForm.enough_age_ind) }}</span>
          <span
            v-else
            v-copy="getOptionName('yesNoOptionsDirver', quoteForm.enough_age_ind)">{{ getOptionName('yesNoOptionsDirver', quoteForm.enough_age_ind) }}</span>
        </div>
        <div class="tr">
          <!--          <span>Are all the driver(s) having more than 2 years driving experience?</span>-->
          <span>Does all the named driver(s) have over 2 years of a proper private vehicle driving license?</span>
          <span v-copy="getOptionName('yesNoOptions', quoteForm.enough_exp_ind)">{{ getOptionName('yesNoOptions', quoteForm.enough_exp_ind) }}</span>
        </div>
        <div
          v-if="quoteForm.no_acci_nor_deduct==0"
          class="tr">
          <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>
          <span v-copy="getOptionName('yesNoOptions', quoteForm.no_acci_nor_deduct)">{{ getOptionName('yesNoOptions', quoteForm.no_acci_nor_deduct) }}</span>
        </div>
        <div
          v-if="quoteForm.no_acci_nor_deduct!=0"
          class="tr">
          <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
          <span v-copy="getOptionName('acciOptions', quoteForm.no_dr_acci_ind)">{{ getOptionName('acciOptions', quoteForm.no_dr_acci_ind) }}</span>
        </div>
        <div
          v-if="quoteForm.no_acci_nor_deduct!=0"
          class="tr">
          <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years? </span>
          <span v-copy="getOptionName('deductOptions', quoteForm.no_dr_deduct_ind)">{{ getOptionName('deductOptions', quoteForm.no_dr_deduct_ind) }}</span>
        </div>
      </template>
      <div>
        <div
          v-for="(item,index) in quick_quote_detail.nm_drvr_list"
          :key="index">
          <div class="tr th">
            <span>{{'Driver'+(index+1)}}</span>
          </div>
          <div
            v-if="quoteForm.class_id == 14 || quoteForm.class_id == 11"
            class="tr">
            <span>Named driver age</span>
            <span v-copy="item.nm_drvr_age_language">{{item.nm_drvr_age_language}}</span>
          </div>
          <div
            v-if="quoteForm.class_id==12&&quoteForm.enough_age_ind==0"
            class="tr"
          >
            <span>Named driver age</span>
            <span v-copy="item.nm_drvr_age_language">{{item.nm_drvr_age_language}}</span>
          </div>
          <div
            v-if="quoteForm.class_id==14"
            class="tr">
            <span >Driving licence of Named Driver</span>
            <span v-copy="item.nm_drvr_exp_language">{{item.nm_drvr_exp_language}}</span>
          </div>
          <div
            v-if="quoteForm.class_id==11&&quoteForm.enough_exp_ind==0||quoteForm.class_id==12"
            class="tr">
            <span>Driving license</span>
            <span v-copy="item.nm_drvr_exp_language">{{item.nm_drvr_exp_language}}</span>
          </div>
          <div
            v-if="quoteForm.no_dr_acci_ind==0&&quoteForm.class_id!=11"
            class="tr">
            <span>Number of accident in last 3 years</span>
            <span v-copy="getAllOptionName('accident_num',item.nm_drvr_acc)">{{getAllOptionName('accident_num',item.nm_drvr_acc)}}</span>
          </div>
          <div
            v-if="quoteForm.no_dr_deduct_ind==0"
            class="tr">
            <span v-if="quoteForm.class_id==11">Number of driving offence point in last 3 years</span>
            <span v-else>Number of driving offence point in last 3 years</span>
            <span v-copy="getAllOptionName('off_points',item.nm_drvr_pt)">{{getAllOptionName('off_points',item.nm_drvr_pt)}}</span>
          </div>
        </div>
      </div>
      <div class="tr">
        <span>
          <!--          <p-->
          <!--            v-for="(item,index) in underwriting"-->
          <!--            :key="index">-->
          <!--            {{item.name}}-->
          <!--          </p>-->
          <p>Confirm All Insurance Underwriting Questions?</p>
        </span>
        <span v-copy="getOptionName('answerList', quick_quote_detail.underwriting_confirm)">{{ getOptionName('answerList', quick_quote_detail.underwriting_confirm) }}</span>
      </div>
      <div
        v-if="benefits.length>0"
        class="tr">
        <span>Insured Items</span>
        <span>
          <span
            v-for="(item,index) in benefits"
            :key="'b'+index"
            v-copy="item">
            {{item}}<br>
          </span>
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
import OMath from '@/utils/math'

export default {
  name: 'MotorQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState('quote', [ 'carModelOptions']),
    amount(){
      let {isrd_vl} = this.quoteForm||{}
      return  OMath.formatMoney(isrd_vl, 2,true)
    },
    underwriting(){
      let {quick_quote_detail={}} = this.quoteForm||{}
      return quick_quote_detail.underwriting||[]
    },
    quick_quote_detail(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail||{}
    },
    isFormDriver(){
      let { no_dr_acci_ind, no_dr_deduct_ind,enough_age_ind,enough_exp_ind,class_id} = this.quoteForm||{}
      return false
    },
    benefits(){
      let {class_id,benefits=[]} = this.quoteForm||{}
      const benefitsList = benefits.reduce((result, item) => {
        if(class_id==14)
          result.push(
            this.getAllOptionName('benefits', item)
          )
        else{
          if(class_id==11)
            result.push(
              this.getAllOptionName11('benefits', item)
            )
          else if(class_id==12)
            result.push(
              this.getAllOptionName12('benefits', item)
            )
        }
        return result
      }, [])
      return benefitsList
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
